var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFieldVisitsMileage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 27.821 33.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8154",
    "data-name": "Group 8154",
    transform: "translate(-7.644 -2.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24871",
    "data-name": "Path 24871",
    d: "M12.057,7.375a13.4,13.4,0,0,0,0,18.928l8.869,8.869a.841.841,0,0,0,1.189,0L30.985,26.3C43.02,13.232,25.13-4.661,12.057,7.375ZM29.8,25.113l-8.275,8.275-8.275-8.275a11.716,11.716,0,0,1,0-16.549C24.678-1.959,40.316,13.685,29.8,25.113Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24872",
    "data-name": "Path 24872",
    d: "M22.974,20.247a3.78,3.78,0,0,0,1,2.54A5.493,5.493,0,0,0,20,27.806a.841.841,0,1,0,1.68.08C21.809,25.219,24.387,24,26.729,24s4.922,1.215,5.048,3.882a.832.832,0,0,0,.88.8.841.841,0,0,0,.8-.88,5.491,5.491,0,0,0-3.97-5.019,3.754,3.754,0,0,0-2.757-6.3,3.7,3.7,0,0,0-3.755,3.756Zm5.828-.026a2.073,2.073,0,1,1-2.086-2.06,2.073,2.073,0,0,1,2.086,2.06Z",
    transform: "translate(-5.208 -5.751)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldVisitsMileage);
export default __webpack_public_path__ + "static/media/FieldVisitsMileage.2b8c2b24642a34adac82106579d678ce.svg";
export { ForwardRef as ReactComponent };